import {
  createNewChatService,
  AssignChatService,
  chatIsActiveService,
} from "../Infrastructure/Chat.service";

export default async function createNewChat(employeeID) {
  const ownerID = localStorage.getItem("userid");
  const chatID = `${ownerID}-${employeeID}`;

  const isActiveResponse = await chatIsActiveService(chatID);
  const isActive = isActiveResponse?.getChat?.active;

  if (!isActive) {
    await createNewChatService({
      active: true,
      id: `${ownerID}-${employeeID}`,
    });
    await AssignChatService({
      chatUserChat_idId: chatID,
      chatUserUser_idId: employeeID,
      id: chatID,
    });
  }

  return chatID;
}
